import {
  faFileLines,
  faVideo,
  faFileImage,
  faFileAudio,
  faLayerGroup,
  faAddressBook,
  faNewspaper,
  faCircleQuestion,
} from "@fortawesome/pro-regular-svg-icons";
import { getMimeFaIcon } from "@utils/shared/media-presentation";

export const CATEGORY_ICON = {
  Asset: faLayerGroup,
  Document: faFileLines,
  Video: faVideo,
  Image: faFileImage,
  Audio: faFileAudio,
  Contact: faAddressBook,
  News: faNewspaper,
  HelpTopic: faCircleQuestion,
};

const buildAssetUrl = (breadcrumbsJson) => {
  try {
    const breadcrumbs = JSON.parse(breadcrumbsJson?.[0] ?? "[]");
    const rootId = breadcrumbs[0]?.key?.split("/")[1];
    const lastKey = breadcrumbs[breadcrumbs.length - 1]?.key;
    return rootId && lastKey ? `/assets/${rootId}/${lastKey}` : "/home";
  } catch {
    return "/home";
  }
};

export const buildResultUrl = ({ type, id, url }) => {
  const rawId = id?.includes("-") ? id.substring(id.indexOf("-") + 1) : id;
  switch (type) {
    case "Document":
      return `/library/documents/all/${rawId}`;
    case "Video":
      return `/library/videos/all/${rawId}`;
    case "Image":
      return `/library/images/all/${rawId}`;
    case "Audio":
      return `/library/audios/all/${rawId}`;
    case "Contact":
      return `/contacts/${rawId}`;
    case "News":
      return `/news/all/${rawId}`;
    case "HelpTopic":
      return `/help/${rawId}`;
    case "Asset":
      return buildAssetUrl(url);
    default:
      return url ?? "/home";
  }
};

export const getMimetypeIcon = (mimetype) => {
  return getMimeFaIcon(mimetype, null, "regular", { fallbackToFile: false });
};
